(function () {
    "use strict";

    jQuery.fn.bgGrab = function (options) {

        jQuery(this).each(function () {
            options = jQuery.extend({
                selector: '> img:first-child'
            }, options);

            var src = jQuery(this).find(options.selector).attr('src');

            jQuery(this).css({
                background: 'url(' + src + ') no-repeat center center',
                backgroundSize: 'cover'
            });

            jQuery(this).find(options.selector).remove();
        });

        return this;
    };
}());
